import Moment from "moment";
import {
  GetSolicitudesApi,
  GetDraftComplains,
  DeleteDraftComplaint,
  GetSolicitudesPendientesTrabajador,
  GetValidacionTrabajadorEmpresa,
  GetInformacionGeneral,
  UpdateDataGestionarSolicitud,
  listaBaterias,
  CrearSolicitud,
  GetSolicitudesApiAuthorized
} from "../../../../../services/solicitudesAgendaSelApi";
import { getLists } from "../../../../Global/actions";
import { getUserInfo } from "../../../../../services/misDatosApi";
import validaciones from "../../../../../helpers/validaciones";
import { setDataAgendaForm } from "../Solicitudes/actions";
import { store } from "../../../../../config/store";
import { formatDateForFilter } from "../../../../../helpers/dateFormat";
import trace from "../../../../../helpers/trace";
import { showToastError, showMessageApi } from "../../../../Main/actions";

export const loading = (isLoading) => ({
  type: "LOADING_CONFIRMACION_SOLICITUDES",
  isLoading,
});
export const changeTabIndexGestionar = (newContentId, tabPosition) => ({
  type: "CHANGE_TABS_INDEX_GESTIONAR",
  newContentId,
  tabPosition,
});
export const clickBtnGestionar = (subTabContent) => ({
  type: "CLICK_BTN_GESTIONAR",
  subTabContent,
});

export const nextStep = () => ({
  type: "NEXT_STEP_CONFIRMAR",
});

export const lastStep = () => ({
  type: "LAST_STEP_CONFIRMAR",
});

export const setStep = (step) => ({
  type: "SET_STEP_CONFIRMAR",
  step,
});

export const setSolicitudesEmpresa = (listaSolicitudes, filtros, total) => ({
  type: "SET_SOLICITUDES_CONFIRMAR",
  listaSolicitudes,
  filtros,
  total,
});

export const setSolicitudesEmpresaFiltrada = (listaSolicitudesFiltrada) => ({
  type: "SET_SOLICITUDES_EMPRESA_FILTRADA_CONFIRMAR",
  listaSolicitudesFiltrada,
});

export const setSolicitudesEmpresaFiltradaTotal = (total) => ({
  type: "SET_SOLICITUDES_EMPRESA_FILTRADA_TOTAL_CONFIRMAR",
  total,
});

export const setSolicitudesEmpresaFiltradaFiltros = (filtros) => ({
  type: "SET_SOLICITUDES_EMPRESA_FILTRADA_FILTROS_CONFIRMAR",
  filtros,
});

export const setShowHideForm = (showHideForm) => ({
  type: "SET_SHOWHIDE_FORM_CONFIRMAR",
  showHideForm,
});

export const setDataNewComplain = (jsonData) => ({
  type: "SET_DATA_NEW_COMPLAIN_CONFIRMAR",
  jsonData,
});

export const setDraft = (jsonData) => ({
  type: "SET_DRAFT_CONFIRMAR",
  jsonData,
});
export const setCleanDataComplain = () => ({
  type: "SET_CLEAN_DATA_COMPLAIN",
});

export const openCloseModalBorrador = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_BORRADOR_CONFIRMAR",
  isOpen,
});

export const setSelectedWorkers = (list) => ({
  type: "SET_SELECTED_WORKERS",
  list,
});

export const openCloseModalGestionar = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_GESTIONAR",
  isOpen,
});

export const openCloseModalRejectGestionar = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_REJECT_GESTIONAR",
  isOpen,
});

export const editingDraft = (editing) => ({
  type: "EDITING_DRAFT_CONFIRMAR",
  editing,
});

export const setDataTrabajador = (data) => ({
  type: "SET_DATA_TRABAJADOR_CONFIRMAR",
  data,
});

export const updateDataGridSolicitudes = (update) => ({
  type: "UPDATE_DATA_GRID_SOLICITUDES_CONFIRMAR",
  update,
});

export const setPendingComplaints = (complaints) => ({
  type: "SET_PENDING_COMPLAINTS_CONFIRMAR",
  complaints,
});

export const disableNewComplaintButton = (disable) => ({
  type: "DISABLE_NEW_COMPLAINT_BUTTON_CONFIRMAR",
  disable,
});

export const openCloseModalContinue = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_CONTINUE_CONFIRMAR",
  isOpen,
});

export const openCloseModalDelete = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_DELETE_CONFIRMAR",
  isOpen,
});

export const setTipoSolicitud = (tipo) => ({
  type: "SET_TIPO_SOLICITUD_CONFIRMAR",
  tipo,
});

export const setDataSelected = (data) => ({
  type: "SET_DATA_SELECTED_CONFIRM",
  data,
});

export const setDataSelectedShow = (data) => ({
  type: "SET_DATA_SELECTED_SHOW_CONFIRM",
  data
})

export const openCloseModalEliminarTrabajador = (isOpen, worker) => ({
  type: "OPEN_CLOSE_MODAL_ELIMINAR_TRABAJADOR",
  isOpen,
  worker,
});

export const setCleanSolicitudConfirmar = () => ({
  type: "SET_CLEAN_SOLICITUD_CONFIRMAR",
});

export const callListMyData = (rutUsuario, lista) => async (dispatch) => {
  await dispatch(getLists(lista));
};

export const doGetComplaint = (filtros) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;
    const request = await GetSolicitudesApi(filtros);
    if (request.status === 200) {
      const result = await request.json();
      dispatch(setSolicitudesEmpresa(result.ListaSolicitudes));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doGetComplaint Confirmación", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doGetDraft = (CompanyId, rutTrabajador) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;

    const request = await GetDraftComplains(CompanyId, rutTrabajador);
    if (request.status === 200) {
      let form = {};
      const result = await request.json();

      form = JSON.parse(result.Complaint.JsonData);
      form.Id = result.Complaint.Id;

      dispatch(setDraft(form));
      dispatch(setStep(form.currentStep));
      dispatch(editingDraft(true));
      dispatch(openCloseModalContinue(true));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("doGetDraft Confirmación", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doDeleteDraft = (idComplaint) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;

    if (idComplaint) {
      const request = await DeleteDraftComplaint(idComplaint);
      if (request.status === 200) {
        dispatch(updateDataGridSolicitudes(true));
        message = "Borrador Eliminado.";
        dispatch(setCleanDataComplain());
        dispatch(setShowHideForm(false));
        dispatch(openCloseModalBorrador(false));
      } else {
        const result = await request.json();
        dispatch(showMessageApi(message, request, result));
      }
      dispatch(showMessageApi(message, request));
    } else {
      dispatch(setCleanDataComplain());
      dispatch(setShowHideForm(false));
      dispatch(openCloseModalBorrador(false));
    }
  } catch (e) {
    trace.error("doDeleteDraft", e);
    dispatch(showToastError());
  }

  dispatch(loading(false));
};
// Llamo datos del trabajador por rut
export const getWorkerData = (showNotifications, jsonData, workerRut, dataActual) => async (dispatch) => {
  if (showNotifications) dispatch(loading(true));
  try {
    if (Object.entries(dataActual).length === 0 && dataActual.constructor === Object) {
      const response = await getUserInfo(workerRut);
      const form = { ...jsonData };
      let message;

      if (response.status === 200) {
        const result = await response.json();
        if (result.Success) {
          const data = {
            Rut: validaciones.formatRut(result.Profile.Rut, { showDots: true, showHyphen: true }),
            FirstName: result.Profile.Name,
            LastName: result.Profile.FatherLastName,
            MothersName: result.Profile.MotherLastName,
            Birthdate: result.Profile.Birthdate,
          };
          form.formInfoTrabajador = {
            ...data,
            ...jsonData.formInfoTrabajador,
          };
          dispatch(setDataTrabajador(data));
          dispatch(setDataNewComplain(form));
        } else if (showNotifications) {
          message = "No se encontró información del usuario.";
        }
      } else {
        const result = await response.json();
        dispatch(showMessageApi(message, response, result));
      }
      dispatch(showMessageApi(message, response));
    }
  } catch (e) {
    trace.error("getWorkerData Confirmación", e);
    dispatch(showToastError());
  }
  if (showNotifications) dispatch(loading(false));
};

export const getSolicitudesPendientes = (modalPendientes, complaintType, fechaPresentacion, data) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;

    const request = await GetSolicitudesPendientesTrabajador(data);
    if (request.status === 200) {
      const result = await request.json();
      if (result.Success) {
        modalPendientes();
        dispatch(setPendingComplaints(result.Complaints));
        const any = result.Complaints.filter((item) => item.TipoSiniestro === complaintType
          && !Moment(fechaPresentacion).isSame(item.FechaSiniestro));

        if (any.length) {
          dispatch(disableNewComplaintButton(true));
        }
      } else {
        dispatch(nextStep());
      }
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("getSolicitudesPendientes", e);
    dispatch(showToastError());
  }

  dispatch(loading(false));
};

export const getSolicitudTrabajadorPendienteEmpresa = (modalPendientes, fechaPresentacion, jsonData, data) => async (dispatch) => {
  dispatch(loading(true));
  try {
    data.Fecha = Moment(data.Fecha).format("DD/MM/YYYY");
    const requestValidacion = await GetValidacionTrabajadorEmpresa(data);
    const form = { ...jsonData };
    let message;

    if (requestValidacion.status === 200) {
      const resultValidacion = await requestValidacion.json();
      if (resultValidacion.Success) {
        modalPendientes();
        dispatch(setPendingComplaints(resultValidacion.ListaValidationsEmployeeCompany));
        const dataTrabajador = {
          Rut: validaciones.formatRut(data.Rut, { showDots: true, showHyphen: true }),
          FirstName: resultValidacion.ListaValidationsEmployeeCompany[0].nombres,
          LastName: resultValidacion.ListaValidationsEmployeeCompany[0].apellidoPaterno,
          MothersName: resultValidacion.ListaValidationsEmployeeCompany[0].apellidoMaterno,
          Birthdate: Moment(resultValidacion.ListaValidationsEmployeeCompany[0].fechaNacimiento, "DD/mm/YYYY"),
          Sexo: resultValidacion.ListaValidationsEmployeeCompany[0].sexo.descripcionSexo,
          Nacionalidad: resultValidacion.ListaValidationsEmployeeCompany[0].nacionalidad.descripcionNacionalidad,
        };
        form.formInfoTrabajador = {
          ...dataTrabajador,
          ...jsonData.formInfoTrabajador,
        };
        dispatch(setDataTrabajador(dataTrabajador));
        dispatch(setDataNewComplain(form));

        if (resultValidacion.ListaValidationsEmployeeCompany.length) {
          dispatch(disableNewComplaintButton(true));
        }
      } else {
        data.Fecha = fechaPresentacion;
        const requestPendientes = await GetSolicitudesPendientesTrabajador(data);
        if (requestPendientes.status === 200) {
          const resultPendientes = await requestPendientes.json();
          if (resultPendientes.Success) {
            modalPendientes();
            dispatch(setPendingComplaints(resultPendientes.Complaints));
            const any = resultPendientes.Complaints.filter((item) => item.TipoSiniestro === data.Tipo
              && !Moment(fechaPresentacion).isSame(item.FechaSiniestro));

            if (any.length) {
              dispatch(disableNewComplaintButton(true));
            }
          } else {
            dispatch(nextStep());
          }
        }
      }
    } else {
      const result = await requestValidacion.json();
      dispatch(showMessageApi(message, requestValidacion, result));
    }
  } catch (e) {
    trace.error("getSolicitudTrabajadorPendienteEmpresa", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const loadDataSelected = (row, onlyShow) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;

    const request = await GetInformacionGeneral(row.data.Id);
    if (request.status === 200) {
      const result = await request.json();
      if(onlyShow){
        dispatch(setDataSelectedShow(result))
      }else{
        if (result.WorkersPending > 0) {
          const Worker = (index) => ({
            Age: null,
            Index: index,
            DocumentNumber: "",
            DocumentType: 0,
            Id: null,
            IsScheduling: false,
            Mail: null,
            Name: "Sin Nombre",
            Phone: null,
            SchedulingDate: null,
          });

          for (let i = 0; i < result.WorkersPending; i++) {
            result.Workers.push(Worker(i));
          }
        }

        //dispatch(setDataSelected(result));
        //dispatch(openCloseModalGestionar(true));

        const requestBaterias = await listaBaterias();
        const resultBaterias = await requestBaterias.json();

        const baterias = resultBaterias && resultBaterias.Pools ? resultBaterias.Pools : [];
        const examenes = resultBaterias && resultBaterias.Exams ? resultBaterias.Exams.map((e) => e.ExamTypeId === 1 ? e : null).filter((f) => f) : [];
        const psicologicos = resultBaterias && resultBaterias.Exams ? resultBaterias.Exams.map((e) => e.ExamTypeId === 2 ? e : null).filter((f) => f) : [];
        let defaultCityId = null;
        let defaultCityDescription = null;

        result.Pools = result.Pools.map((e) => {
          const pool = baterias.find((ee) => ee.Id === e.PoolId);
          if (pool) {
            pool.AchsOffices = pool.AchsOffices.map((office) => {
              if (office.Id === e.AchsOfficeId) {
                defaultCityId = office.Id;
                defaultCityDescription = office.Description
              }
              return {
                ...office,
                selected: office.Id === e.AchsOfficeId,
              };
            });
          }
          return pool;
        }).filter((f) => f);

        result.PsychologicalExams = result.PsychologicalExams.map((e) => {
          const exam = psicologicos.find((ee) => ee.Id === e.ExamId);
          if (exam) {
            exam.AchsOffices = exam.AchsOffices.map((office) => {
              if (office.Id === e.AchsOfficeId) {
                defaultCityId = office.Id;
                defaultCityDescription = office.Description
              }
              return {
                ...office,
                selected: office.Id === e.AchsOfficeId,
              };
            });
          }
          return exam;
        }).filter((f) => f);

        result.AdditionalExams = result.AdditionalExams.map((e) => {
          const exam = examenes.find((ee) => ee.Id === e.ExamId);
          if (exam) {
            exam.AchsOffices = exam.AchsOffices.map((office) => {
              if (office.Id === e.AchsOfficeId) {
                defaultCityId = office.Id;
                defaultCityDescription = office.Description
              }
              return {
                ...office,
                selected: office.Id === e.AchsOfficeId,
              };
            });
          }
          return exam;
        }).filter((f) => f);

        result.defaultCityId = defaultCityId;
        result.defaultCityDescription = defaultCityDescription;
        result.isExamsUpdate = false;
        result.isPoolsUpdate = false;
        result.isWorkersUpdate = false;      
        dispatch(setDataSelected(result));
        dispatch(setDataAgendaForm({
          baterias, examenes, psicologicos,
        }));
      }      
    } else {
      dispatch(openCloseModalGestionar(false));
      dispatch(setDataSelected({}));
      dispatch(setDataSelectedShow(null))
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    dispatch(openCloseModalGestionar(false));
    dispatch(setDataSelected({}));
    dispatch(setDataSelectedShow(null))
    trace.error("loadDataSelected", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const updateSolicitudSel = (data) => async (dispatch) => {
  try {
    let message;

    if ((!data.isPoolsUpdate && !data.isExamsUpdate) && !data.isWorkersUpdate) {
      dispatch(clickBtnGestionar(false));
      return;
    }

    dispatch(loading(true));
    const formattedData = {};
    formattedData.isWorkersUpdate = data.isWorkersUpdate;
    formattedData.isRequestHeaderUpdate = data.isWorkersUpdate || data.isRequestHeaderUpdate;
    formattedData.isPoolsUpdate = data.isPoolsUpdate;
    formattedData.isExamsUpdate = data.isExamsUpdate;
    formattedData.StatusId = data.StatusId;
    formattedData.Id = data.Id;
    formattedData.PetitionerRut = data.PetitionerRut;
    formattedData.AuthorizedRut = data.AuthorizedRut;
    formattedData.CostCenter = data.CostCenter;
    formattedData.WorkerPositionId = data.WorkerPositionId;
    formattedData.OtherWorkerPosition = data.OtherWorkerPosition;
    formattedData.RequestTypeId = data.RequestTypeId;
    formattedData.ProposalDate = data.ProposalDate;
    formattedData.Observations = data.Observations;
    formattedData.ProposalDateEnd = data.ProposalDateEnd;
    formattedData.Comment = data.Comment;
    formattedData.RejectComment = data.RejectComment;
    formattedData.WorkersQuota = data.WorkersQuota;
    formattedData.CompanyRut = data.CompanyRut;

    if (data.isExamsUpdate) {
      formattedData.PsychologicalExams = data.PsychologicalExams.length > 0 ?
        data.PsychologicalExams.map((e) => {
          if (!e.Id && !e.AchsOffices && e.AchsOffices.length <= 0) { return null; }
          //let OfficeId = e.AchsOffices ? e.AchsOffices.find((o) => o.selected === true) : null;
          //OfficeId = OfficeId && OfficeId.Id ? OfficeId.Id : null;
          return {
            Id: e.Id ? e.Id : null,
            OfficeId: data.defaultCityId,
          };
        }).filter((f) => f) : null;

      formattedData.AdditionalExams = data.AdditionalExams.length > 0 ?
        data.AdditionalExams.map((e) => {
          if (!e.Id && !e.AchsOffices && e.AchsOffices.length <= 0) { return null; }
          //let OfficeId = e.AchsOffices ? e.AchsOffices.find((o) => o.selected === true) : null;
          //OfficeId = OfficeId && OfficeId.Id ? OfficeId.Id : null;
          return {
            Id: e.Id ? e.Id : null,
            OfficeId: data.defaultCityId,
          };
        }).filter((f) => f) : null;
    } else {
      formattedData.PsychologicalExams = [];
      formattedData.AdditionalExams = [];
    }

    if (data.isPoolsUpdate) {
      formattedData.Pools = data.Pools.length > 0 ?
        data.Pools.map((e) => {
          if (!e.Id && !e.AchsOffices && e.AchsOffices.length <= 0) { return null; }
          //let OfficeId = e.AchsOffices ? e.AchsOffices.find((o) => o.selected === true) : null;
          //OfficeId = OfficeId && OfficeId.Id ? OfficeId.Id : null;
          return {
            Id: e.Id ? e.Id : null,
            OfficeId: data.defaultCityId,
          };
        }).filter((f) => f) : null;
    } else {
      formattedData.Pools = [];
    }
    if (data.isWorkersUpdate) {
      const newList = [
        ...data.Workers,
        ...data.newWorkers,
      ];
      formattedData.WorkersQuota = newList.length;
      formattedData.Workers = newList;
    } else {
      formattedData.Workers = [];
    }
    const request = await CrearSolicitud(formattedData);
    if (request.status === 201) {
      dispatch(clickBtnGestionar(false));
      if (data.isWorkersUpdate) { dispatch(loadDataSelected({ data })); }
      message = "La solicitud ha sido editada con éxito.";
      const { global, confirmacionSolicitudesAgendaSel } = store.getState();
      const filters = {
        from: formatDateForFilter(Moment().subtract(1, "year")),
        to: formatDateForFilter(Moment()),
        companyRut: global.companyId,
        AuthorizedRut: global.userData.RUT,
        StatusId: confirmacionSolicitudesAgendaSel.selectedTipoSolicitud.value.value,
      };
      dispatch(loadDataGrid(filters));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
    dispatch(showMessageApi(message, request));
  } catch (e) {
    trace.error("updateSolicitudSel", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const updateDataGestionar = (data) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;
    const request = await UpdateDataGestionarSolicitud(data);
    if (request.status === 200) {
      dispatch(setDataSelected({}));
      dispatch(openCloseModalGestionar(false));
      dispatch(openCloseModalRejectGestionar(false));
      dispatch(updateDataGridSolicitudes(true));
      if (data.RequestStatus === 2) {
        message = "La solicitud ha sido enviada para ser agendada.";
      } else if (data.RequestStatus === 3) {
        message = "La solicitud ha sido rechazada correctamente.";
      }
      const { global, confirmacionSolicitudesAgendaSel } = store.getState();
      const filters = {
        from: formatDateForFilter(Moment().subtract(1, "year")),
        to: formatDateForFilter(Moment()),
        companyRut: global.companyId,
        AuthorizedRut: global.userData.RUT,
        StatusId: confirmacionSolicitudesAgendaSel.selectedTipoSolicitud.value.value,
      };
      dispatch(loadDataGrid(filters));
    } else {
      dispatch(setDataSelected({}));
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
    dispatch(showMessageApi(message, request));
  } catch (e) {
    dispatch(setDataSelected({}));
    trace.error("updateDataGestionar", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const loadDataGrid = (filtros) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let message;
    const request = await GetSolicitudesApiAuthorized(filtros);
    if (request.status === 200) {
      const result = await request.json();
      const statusId = filtros && filtros.StatusId ? filtros.StatusId : false;
      dispatch(setSolicitudesEmpresa([...result.Data], null, null));
      dispatch(doGetSolicitudesFilters(result.Data, statusId));
      dispatch(setSolicitudesEmpresaFiltrada([...result.Data]));
    } else {
      const result = await request.json();
      dispatch(showMessageApi(message, request, result));
    }
  } catch (e) {
    trace.error("loadDataGrid", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doGetSolicitudesFilters = (ListaSolicitudes, statusId) => async (dispatch) => {
  try {
    const filtros = [
    ];
    if (statusId === 3) {
      filtros.push({ column: "RejectDate", name: "Fecha rechazo", type: "date" });
    } else if (statusId === 2) {
      filtros.push({ column: "ApprovalDate", name: "Fecha aprobación", type: "date" });
    } else if (statusId === 1) {
      filtros.push({ column: "CreationDate", name: "Fecha de envío", type: "date" });
    }
    let Solicitante = ListaSolicitudes.map((item) => ({ text: item.PetitionerName, value: item.PetitionerName })).filter((e) => e.text && e.value);
    Solicitante = validaciones.getUnique(Solicitante, "text");
    filtros.push({
      column: "PetitionerName", name: "Solicitante", values: Solicitante,
    });
    dispatch(setSolicitudesEmpresaFiltradaFiltros(filtros));
  } catch (e) {
    trace.error("doGetSolicitudesFilters", e);
    dispatch(showToastError());
  }
};
